<template>
    <div class="">
        <el-dialog custom-class="pu-dialog" :close-on-click-modal="false" :show-close="false"
            :visible.sync="internalIsShow" :width="width" :center="center" :append-to-body="appendToBody">
            <template slot="title">
                <div class="header-title">
                    <span class="title-text"><i class="el-icon-info" :class="type" v-show="type"></i>{{ title }}</span>
                    <el-link type="text" class="title-close" @click="cancelEvent" icon="el-icon-close"
                        :underline="false"></el-link>
                </div>
            </template>
            <template>
                <div class="dialog-body" :style="{ padding: padding, textAlign: textAlign }">
                    <!-- <slot name="content">
                        <span>{{ msg }}</span>
                    </slot> -->
                    <p v-html="msg"></p>
                </div>
            </template>
            <template slot="footer">
                <div class="flex justify-center">
                    <slot name="footer">
                        <template v-if="!dislocationBtn">
                            <el-button size="small" class="w-[120]" @click="cancelEvent" v-show="showCancelButton">{{
                                cancelButtonText }}</el-button>
                            <el-button size="small" type="primary" class="w-[120]" @click="callbackEvent">{{
                                confirmButtonText }}</el-button>
                        </template>
                        <template v-else>
                            <el-button size="small" class="w-[120]" @click="callbackEvent">{{
                                confirmButtonText }}</el-button>
                            <el-button size="small"  type="primary" class="w-[120]" @click="cancelEvent" v-show="showCancelButton">{{
                                cancelButtonText }}</el-button>
                        </template>
                    </slot>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'dg-alert',
    props: {
        showCancelButton: {
            type: Boolean,
            default: false
        },
        confirmButtonText: {
            type: String,
            default: '确定'
        },
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        title: {
            type: String,
            default: '提示'
        },
        msg: {
            type: String,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: false
        },
        dangerouslyUseHTMLString: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: null
        },
        callback: {
            type: Function,
            default: () => {
                console.log('点击了callback');
            }
        },
        cancel: {
            type: Function,
            default: () => {
                console.log('点击了cancel');
            }
        },
        appendToBody: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '480px'
        },
        center: {
            type: Boolean,
            default: true
        },
        padding: {
            type: String,
            default: '20px 25px'
        },
        textAlign: {
            type: String,
            default: 'center'
        },
    },
    data() {
        return {
            internalIsShow: this.isShow,
            dislocationBtn: false,
        };
    },
    watch: {
        isShow(newVal) {
            this.internalIsShow = newVal;
        },
        // internalIsShow(newVal) {
        //     this.$emit('update:isShow', newVal);
        // }
    },
    methods: {
        // 关闭弹窗
        close() {
            this.$dgAlertClose()
            // this.internalIsShow = false;
        },
        // alert 插件点击阴影区域关闭弹窗
        closeMask() {
            if (this.type === 'alert') {
                this.close();
            }
        },
        // confirm 插件点击取消触发的事件
        cancelEvent() {
            this.cancel();
            this.close();
        },
        // confirm 插件点击确定触发的事件
        callbackEvent() {
            this.callback('confirm');
            this.close();
        }
    }
}
</script>

<style scoped lang="less">
// @import '~@/assets/css/var.less';
/deep/ .pu-dialog {
    background-color: #ffffff;

    .el-dialog__header {
        padding: 30px 20px 10px !important;

        .header-title {
            line-height: 24px;
            font-size: 20px !important;
            color: #303133;
            position: relative;

            .warning {
                color: #e6a23c;
                font-size: 20px !important;
                margin-right: 4px;
            }

            .title-close {
                padding: 0 !important;
                line-height: 24px;
                top: 0;
                float: right;
                font-size: 20px;
                color: #303133;
                position: absolute;
                right: 0;
            }
        }
    }

    .el-dialog__body {
        padding: 0 !important;
    }

    .el-dialog__footer {
        padding: 0px 20px 40px !important;

        .el-button {
            width: 120px;
        }
    }
}
</style>